import React from 'react';
import { XIcon, CheckIcon, ArrowDownIcon, ArrowRightIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { beforeItems, afterItems } from '../../data/landing';
export function Transformation() {
  return <section className="bg-white py-16 sm:py-24" aria-labelledby="transformation-title" data-id="element-267" data-mp="1nq11jx92w97r">
      <div className="mx-auto max-w-5xl px-5" data-id="element-268" data-mp="1irprblevfwp0">
        <div className="text-center" data-id="element-269" data-mp="2fgnn96ycy0nr">
          <p className="mx-auto max-w-2xl text-balance font-display text-xl font-bold italic text-navy-900/60 sm:text-2xl" data-id="element-270" data-mp="2fflyy0sbzho3">
            From a Physical Therapist Who Hesitates When Facing a Complex Disc Herniation Case…
          </p>
          <h2 id="transformation-title" className="mx-auto mt-3 max-w-3xl text-balance font-display text-[2rem] font-black leading-tight text-navy-900 sm:text-5xl" data-id="element-271" data-mp="26miswdk0m73h">
            …to a Professional With a <span className="text-brand-600" data-id="element-272" data-mp="2udxyqgb036jh">Structured System</span> to Assess, Decide,
            and Plan.
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-lg text-navy-900/75" data-id="element-273" data-mp="157wmq8rzbc49">
            A practical framework designed to help you reduce guesswork and bring more structure to your clinical
            process.
          </p>
        </div>

        <div className="mt-10 grid items-stretch gap-4 md:grid-cols-[1fr_auto_1fr] md:gap-5" data-id="element-274" data-mp="wfcubq2a63rv">
          <div className="rounded-3xl bg-alert-50 p-6 ring-1 ring-alert-200 sm:p-8" data-id="element-275" data-mp="10fwrgtmut7e0">
            <div className="flex items-center gap-2" data-id="element-276" data-mp="mgx3zpb2uyjf">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-alert-500" data-id="element-277" data-mp="rgrvnv2ofs5j">
                <XIcon className="h-5 w-5 text-white" strokeWidth={3} aria-hidden="true" data-id="element-278" data-mp="dh0clfxazlko" />
              </span>
              <h3 className="text-xl font-black uppercase tracking-wide text-alert-700" data-id="element-279" data-mp="hi2b1ujebtll">Before</h3>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-280" data-mp="27ursgx6871ok">
              {beforeItems.map(item => <li key={item} className="flex gap-3 text-base leading-snug text-navy-900/85" data-id="element-281" data-mp="2bx4tx9dxwdfj">
                  <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-alert-500" strokeWidth={3} aria-hidden="true" data-id="element-282" data-mp="3ku33i3waw8u4" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="flex items-center justify-center" aria-hidden="true" data-id="element-283" data-mp="3bs3kx75n0wp2">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-brand-500 text-white" data-id="element-284" data-mp="36u23eqnv15fp">
              <ArrowDownIcon className="h-6 w-6 md:hidden" data-id="element-285" data-mp="7f6q4rw57xg6" />
              <ArrowRightIcon className="hidden h-6 w-6 md:block" data-id="element-286" data-mp="7groytphq2ju" />
            </span>
          </div>

          <div className="rounded-3xl bg-navy-900 p-6 ring-2 ring-brand-500 sm:p-8" data-id="element-287" data-mp="3fftw8nukp49">
            <div className="flex items-center gap-2" data-id="element-288" data-mp="3upwl41ovmsir">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-cta-500" data-id="element-289" data-mp="3ptfyjbxbsm7s">
                <CheckIcon className="h-5 w-5 text-white" strokeWidth={3} aria-hidden="true" data-id="element-290" data-mp="r2waie1r2vfd" />
              </span>
              <h3 className="text-lg font-black uppercase tracking-wide text-white sm:text-xl" data-id="element-291" data-mp="mb5w9wzoznio">
                With Hernia Clinical Playbook™
              </h3>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-292" data-mp="yldp2yohh0f7">
              {afterItems.map(item => <li key={item} className="flex gap-3 text-base font-medium leading-snug text-white" data-id="element-293" data-mp="13kqn8fkt1tx3">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand-400" strokeWidth={3} aria-hidden="true" data-id="element-294" data-mp="17nd8fxmz0glb" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <CtaButton className="mt-12" label="I want to assess & plan with a system" data-id="element-295" data-mp="1hjztonj7l9nv" />
      </div>
    </section>;
}